module.exports = __webpack_public_path__ + "static/media/loading-ritual-black.f474b316.gif";